/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The platform-managed inference key whose cap is reported
 */
export const SpendCapKeyType = {
  Chat: "chat",
  Internal: "internal",
} as const;
/**
 * The platform-managed inference key whose cap is reported
 */
export type SpendCapKeyType = ClosedEnum<typeof SpendCapKeyType>;

export type SpendCap = {
  /**
   * The platform-managed inference key whose cap is reported
   */
  keyType: SpendCapKeyType;
  /**
   * The monthly inference spend cap in USD
   */
  monthlyCredits: number;
};

/** @internal */
export const SpendCapKeyType$inboundSchema: z.ZodMiniEnum<
  typeof SpendCapKeyType
> = z.enum(SpendCapKeyType);

/** @internal */
export const SpendCap$inboundSchema: z.ZodMiniType<SpendCap, unknown> = z.pipe(
  z.object({
    key_type: SpendCapKeyType$inboundSchema,
    monthly_credits: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "key_type": "keyType",
      "monthly_credits": "monthlyCredits",
    });
  }),
);

export function spendCapFromJSON(
  jsonString: string,
): SafeParseResult<SpendCap, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpendCap$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpendCap' from JSON`,
  );
}
